import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import AuthService from "../../services/authService";

class SlideOut extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuList: null,
        }
        this.menuList = [];
    }

    componentDidMount() {
        this.generateMenuList();
        this.getWindowHeight();
    }

    componentDidUpdate() {
        this.getWindowHeight();
    }

    generateMenuList() {
        let user = JSON.parse(AuthService.getUser());
        let categoryOrder = [];
        categoryOrder = user["category_order"]
        let dashboard =
            (
                <li className="large-text" key="dashboard">
                    <Link to='/'>Course Introduction</Link>
                </li>
            );

        let progress =
            <li className="large-text" key="progress">
                <Link to='/progress/'>Progress</Link>
            </li>;

        let coreTopics =
            <li className="large-text orange-text" key="topics">
                6 Core Topics
            </li>;

        let profile =
            <li className="large-text" key="profile">
                <Link to='/profile/'>Profile</Link>
            </li>;
        this.menuList.push(dashboard, progress, profile, coreTopics);

        let linkAddress, linkTitle;


        categoryOrder.forEach(
            category => {
                switch (category.category_id) {
                    case 1:
                        linkAddress = '/section/communication/';
                        linkTitle = 'Communication';
                        break;
                    case 2:
                        linkAddress = '/section/conflict-and-repair/';
                        linkTitle = 'Conflict and Repair';
                        break;
                    case 3:
                        linkAddress = '/section/money/';
                        linkTitle = 'Money';
                        break;
                    case 4:
                        linkAddress = '/section/sex-and-intimacy/';
                        linkTitle = 'Sex & Intimacy';
                        break;
                    case 5:
                        linkAddress = '/section/family-of-origin/';
                        linkTitle = 'Family of Origin';
                        break;
                    case 6:
                        linkAddress = '/section/self-discovery/';
                        linkTitle = 'Self Discovery';
                        break;

                }

                let link =
                    (
                        <li className="small-text" key={linkTitle}>
                            <Link to={linkAddress}>{linkTitle}</Link>
                        </li>
                    );
                this.menuList.push(link);
            }
        );
        let extrasButton =
            <li className="menu-button" key="extras">
                <Link to='/extras/'>
                    <button className="yellow-btn slideout-btn">Extras</button>
                </Link>
            </li>;
        let twogetherButton =
            <li className="menu-button" key="extras">
                <a target="_blank" href='https://d3ug1m98su9wd.cloudfront.net/resources/twogether-in-texas-quiz.pdf'>
                    <button className="yellow-btn slideout-btn">Twogether in Texas</button>
                </a>
            </li>;
        let logOutButton =
            <li className="menu-button" id="logout-button" onClick={AuthService.logout} key="logout">
                <Link to='/'>
                    <button className="yellow-btn logout slideout-btn">Log Out</button>
                </Link>
            </li>;

        this.menuList.push(extrasButton, twogetherButton, logOutButton);
        this.setState({
            menuList: this.menuList
        })
    }

    getWindowHeight() {
        let windowHeight = document.body.clientHeight;
        // console.log("window height", windowHeight)
        let slideOut = document.querySelector('.menu-slideout');
        // console.log("slideout", slideOut)
        slideOut.style.height = windowHeight + "px";

    }

    render() {
        return (
            <div className="menu-slideout slide-enter">
                <div className="close-menu" onClick={this.props.handleClose}>
                    X
                </div>
                <div className="menu-links">
                    <ul className="menu-list">
                        {this.state.menuList}
                    </ul>
                </div>

                <div className="nav-social">
                    <ul>
                        <li className="social-icon">
                            <a href="https://www.instagram.com/premaritalcourse/" target="_blank">
                                <i className="fa fa-instagram"></i>
                            </a>
                        </li>
                        <li className="social-icon">
                            <a href="https://twitter.com/marriage365" target="_blank">
                                <i className="fa fa-twitter"></i>
                            </a>
                        </li>
                        <li className="social-icon">
                            <a href="https://www.facebook.com/marriage365/" target="_blank">
                                <i className="fa fa-facebook-f"></i>
                            </a>
                        </li>
                    </ul>
                </div>

            </div>
        )
    }


}

export default SlideOut;
